import { render } from "./BookingFormPax.vue?vue&type=template&id=5b2a4b3b&scoped=true"
import script from "./BookingFormPax.vue?vue&type=script&lang=js"
export * from "./BookingFormPax.vue?vue&type=script&lang=js"

import "./BookingFormPax.vue?vue&type=style&index=0&id=5b2a4b3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2a4b3b"]])

export default __exports__